import { useEffect } from 'react';
import { terminate } from '@shopify/web-worker';
import { useLazyRef } from '@shopify/react-hooks';

function useWorker(creator, ...args) {
  const {
    current: worker
  } = useLazyRef(() => creator(...args));
  useEffect(() => {
    return () => {
      terminate(worker);
    };
  }, [worker]);
  return worker;
}

export { useWorker };
